import { render } from "./VegaSystem.vue?vue&type=template&id=75e3b498&scoped=true"
import script from "./VegaSystem.vue?vue&type=script&lang=js"
export * from "./VegaSystem.vue?vue&type=script&lang=js"

import "./VegaSystem.vue?vue&type=style&index=0&id=75e3b498&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75e3b498"]])

export default __exports__